<form autocomplete="off" [formGroup]="interestRateForm" (submit)="onSubmit()" id="interestRateForm" class="adj-form">
  <div *ngIf="checkLoader(); else loading">
    <app-adjustement-modal-template title="{{ titleText }}">
      <!-- <div class="overlay" *ngIf="showLoader">
        <app-spinner></app-spinner>
      </div> -->

      <div header>
        <div class="row">
          <div class="col-lg-12 p-2 align-self-center">
            <label for="interestRate">Interest Rate *</label>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 p-2 align-self-center">
            <span class="ey-float-label">
              <input
                type="number"
                [appNoDecimals]="false"
                class="form-control"
                id="interestRate"
                name="interestRate"
                formControlName="interestRate"
                [readOnly]="readOnly"
                appLabelFloat
              />
              <label for="interestRate">Enter Interest Rate in %</label>
              <app-validation-errors [control]="interestRateForm.controls.interestRate" [customErrorMsg]="customErrorMessage"></app-validation-errors>
            </span>
          </div>
        </div>
      </div>
      <div body>
        <div class="row" *ngIf="!readOnly">
          <div class="col-lg-12 p-2 align-self-center">
            <app-file-upload
              [fileExt]="fileExtension"
              [maxFiles]="1"
              [maxSize]="5"
              (uploadStatus)="upload($event)"
              (deleteFile)="deleteFile($event)"
            ></app-file-upload>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 p-2 align-self-center" *ngIf="IsDropdownVisible()">
            <select
              class="form-control form-select"
              [disabled]="readOnly"
              id="irFileList"
              name="irFileList"
              (change)="changeIRFile($event.target.value)"
            >
              <option selected="interestRateSourceDocPath">Choose Existing File</option>
              <option *ngFor="let file of irFileList">
                {{ file }}
              </option>
            </select>
            <app-validation-errors
              [control]="interestRateForm.controls.interestRateSourceDocPath"
              [customErrorMsg]="customRequiredMessage"
            ></app-validation-errors>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 p-2 align-self-center">
            <span class="ey-float-label">
              <input
                type="text"
                class="form-control"
                id="interestRateSource"
                name="interestRateSource"
                formControlName="interestRateSource"
                [readOnly]="readOnly"
                [ngStyle]="{ 'border-color': customRequiredMessage !== '' ? '#ff4136' : '#dee2e6' }"
                maxlength="500"
                appLabelFloat
              />
              <div *ngIf="customRequiredMessage !== ''" class="text-danger">
                <p [ngStyle]="{ 'font-size.px': 10 }">{{ customRequiredMessage }}</p>
              </div>
              <label for="interestRateSource">Enter Source</label>
            </span>
          </div>
        </div>
        <span layout="row" class="horizontalLine"><hr flex /></span>
        <div class="row">
          <div class="col-lg-12 p-2 align-self-center">
            <label for="interestRateSourceDocPath">Uploaded Document</label>
          </div>
          <div class="col-lg-12 p-2 align-self-center" *ngIf="IsDocumentContainerVisible(); else noDocs">
            <Span class="doc-block">
              <table style="width: 100%">
                <tr>
                  <td style="text-align: left">
                    <input
                      type="text"
                      class="fileText"
                      id="interestRateSourceDocPath"
                      name="interestRateSourceDocPath"
                      formControlName="interestRateSourceDocPath"
                      disabled
                      appLabelFloat
                      style="border: 0px transparent; min-width: 300px"
                    />
                  </td>
                  <td style="text-align: right">
                    <div>
                      <span [ngStyle]="{ 'font-size.px': 14 }"> {{ fileLength + 'MB ' }}</span>
                    </div>
                  </td>
                  <td style="text-align: right">
                    <button type="button" (click)="exportInterestRateFile()" class="export-link" title="Export to .pdf/ .xls/ .doc .txt">
                      <i class="material-icons">cloud_download</i>
                    </button>
                  </td>
                  <td style="text-align: right">
                    <div>
                      <button type="button" (click)="deleteInterestRateSourceOrDoc('doc')" class="export-link" [disabled]="readOnly">
                        <i class="material-icons delete-icon">close</i>
                      </button>
                    </div>
                  </td>
                </tr>
              </table>
            </Span>
          </div>
          <ng-template #noDocs>
            <div class="col-lg-12 p-2 align-self-center">
              <span class="notFoundMsg"> No Documents found</span>
            </div>
          </ng-template>
        </div>
        <div class="row">
          <div class="col-lg-12 p-2 align-self-center">
            <label for="interestRateSourceDocPath">Source</label>
          </div>
          <div class="col-lg-12 p-2 align-self-center" *ngIf="IsSourceContainerVisible(); else noSource">
            <Span class="source-block">
              <table style="width: 100%">
                <tr>
                  <td style="text-align: left">
                    {{ interestRateData.interestRateSource }}
                  </td>
                  <td style="text-align: right">
                    <div>
                      <button type="button" (click)="deleteInterestRateSourceOrDoc('source')" class="export-link" [disabled]="readOnly">
                        <i class="material-icons delete-icon">close</i>
                      </button>
                    </div>
                  </td>
                </tr>
              </table>
            </Span>
          </div>
          <ng-template #noSource>
            <div class="col-lg-12 p-2 align-self-center">
              <span class="notFoundMsg"> No Source found</span>
            </div>
          </ng-template>
        </div>
      </div>
      <div footer>
        <button type="button" class="btn btn-default m-2" (click)="close()">Cancel</button>
        <button type="button" type="submit" class="btn btn-primary m-2" [disabled]="!isInterestRateFormValid" (click)="save()">
          {{ saveButtonText }}
        </button>
      </div>
    </app-adjustement-modal-template>
  </div>
</form>
<ng-template #loading>
  <div class="modal-wrapper">
    <div class="overlay">
      <app-spinner></app-spinner>
    </div>
  </div>
</ng-template>
